/** Shared réparations helpers — Centre Activité HUB-F. */

/** DATA-01 — statuts « en cours » canoniques (magasin_stats.py, ne pas élargir). */
export const DATA01_IN_PROGRESS_STATUSES = [
  'En Cours',
  'En cours',
  'Attente Pièces',
  'Attente pieces',
  'Reçu',
  'Recu',
  'En attente',
  'En Attente',
];

export const REPARATION_SECTIONS = {
  OVERVIEW: 'overview',
  EN_COURS: 'en_cours',
  ATTENTE_PIECE: 'attente_piece',
  TERMINE: 'termine',
  RECENT: 'recent',
};

export function magasinScopeLabel(magasinId) {
  if (!magasinId || magasinId === 'ALL') return 'Tous les magasins';
  return magasinId.toUpperCase();
}

export function formatRepairDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function isInDateRange(isoDate, dateDebut, dateFin) {
  if (!dateDebut && !dateFin) return true;
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return !dateDebut && !dateFin;
  const day = d.toISOString().slice(0, 10);
  if (dateDebut && day < dateDebut) return false;
  if (dateFin && day > dateFin) return false;
  return true;
}

export function matchesRepairSearch(device, search) {
  if (!search?.trim()) return true;
  const q = search.trim().toLowerCase();
  const haystack = [
    device.ref,
    device.client_name,
    device.client_phone,
    device.model,
    device.problem,
    device.technician_name,
    device.status,
    device.magasin_id,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return haystack.includes(q);
}

export function statusBadgeClass(status) {
  const s = (status || '').toLowerCase();
  if (s.includes('termin')) return 'rm-badge rm-badge--success';
  if (s.includes('livré') || s.includes('livre') || s.includes('récup')) return 'rm-badge rm-badge--muted';
  if (s.includes('attente') && s.includes('piè')) return 'rm-badge rm-badge--muted';
  if (s.includes('non')) return 'rm-badge rm-badge--danger';
  if (DATA01_IN_PROGRESS_STATUSES.some((x) => x.toLowerCase() === s)) return 'rm-badge rm-badge--muted';
  return 'rm-badge rm-badge--muted';
}

export function isData01InProgress(status) {
  return DATA01_IN_PROGRESS_STATUSES.includes(status);
}

export function isAttentePiece(status) {
  const s = (status || '').toLowerCase();
  return s.includes('attente') && (s.includes('piè') || s.includes('piece'));
}

export function isTermine(status) {
  const s = (status || '').toLowerCase();
  return s.includes('termin') && !s.includes('non');
}

export function isPretLivrer(status) {
  return isTermine(status);
}

export function isLivre(status) {
  const s = (status || '').toLowerCase();
  return s.includes('livré') || s.includes('livre') || s.includes('récup') || s.includes('recup');
}

export function isEnCoursSection(status) {
  if (isAttentePiece(status) || isTermine(status) || isLivre(status)) return false;
  const s = (status || '').toLowerCase();
  return s.includes('en cours') || s.includes('reçu') || s.includes('recu')
    || (s.includes('en attente') && !s.includes('piè') && !s.includes('depot') && !s.includes('dépôt'));
}

export function computeMagasinRepairCounts(devices = []) {
  const counts = { M1: { en_cours: 0, attente_piece: 0, termine: 0 }, M2: { en_cours: 0, attente_piece: 0, termine: 0 } };
  devices.forEach((d) => {
    const mag = (d.magasin_id || 'M1').toUpperCase();
    if (!counts[mag]) counts[mag] = { en_cours: 0, attente_piece: 0, termine: 0 };
    if (isData01InProgress(d.status)) counts[mag].en_cours += 1;
    if (isAttentePiece(d.status)) counts[mag].attente_piece += 1;
    if (isTermine(d.status)) counts[mag].termine += 1;
  });
  return counts;
}

export function activiteReparationsLinkFromFilters(filters) {
  const params = new URLSearchParams({ tab: 'reparations' });
  if (filters?.search) params.set('search', filters.search);
  if (filters?.date_debut) params.set('date_debut', filters.date_debut);
  if (filters?.date_fin) params.set('date_fin', filters.date_fin);
  if (filters?.magasin_id) params.set('magasin_id', filters.magasin_id);
  if (filters?.period) params.set('period', filters.period);
  return `/activite?${params.toString()}`;
}
